var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.value,"placeholder":"Select State","filterable":"","loading":_vm.loading,"no-match-text":" "},on:{"input":_vm.updateState}},_vm._l((_vm.allUSStates),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }